export const initRecipePages = () => {
    const recipeArchive = document.querySelector(".recipe-archive") as HTMLElement;
    const recipePage = document.querySelector(".recipe-page") as HTMLElement;
    const recipePageType = document.querySelector(".recipe-pagetype") as HTMLElement;
    const productArchive = document.querySelector(".product-archive") as HTMLElement;
    const productPage = document.querySelector(".product-page") as HTMLElement;
    const productPageType = document.querySelector(".product-pagetype") as HTMLElement;
    if (recipePageType) {
        /**
         * Toggle navigation on mobile & tablet.
         */
        const buttonOpen = recipePageType.querySelector(".button--open") as HTMLButtonElement;
        const buttonClose = recipePageType.querySelector(".button--close") as HTMLButtonElement;

        buttonOpen.addEventListener("click", () => {
            recipePageType.classList.add("nav--open");
        });

        buttonClose.addEventListener("click", () => {
            recipePageType.classList.remove("nav--open");
        });
    }
    if (productPageType) {
        /**
         * Toggle navigation on mobile & tablet.
         */
        const buttonOpen = productPageType.querySelector(".button--open") as HTMLButtonElement;
        const buttonClose = productPageType.querySelector(".button--close") as HTMLButtonElement;

        buttonOpen.addEventListener("click", () => {
            productPageType.classList.add("nav--open");
        });

        buttonClose.addEventListener("click", () => {
            productPageType.classList.remove("nav--open");
        });
    }


    if (recipeArchive) {
        /**
         * Update amount of hits when user have searched
         * & Hide CategoryPuffs while a search is active.
         */
        const numberOfHitsSpan = recipeArchive.querySelector(".number-of-hits") as HTMLSpanElement;
        const numberOfHitsText = recipeArchive.querySelector(".number-of-hits-text") as HTMLSpanElement;
        if (numberOfHitsSpan) {
            const numberOfHits = recipeArchive.querySelectorAll(".recipe-puff-item");
            numberOfHitsSpan.textContent = numberOfHits.length.toString();

            if (numberOfHits.length == 1) {
                numberOfHitsText.textContent = "Träff på";
            }

            const categoryPuffBlock: HTMLElement = document.querySelector(".category-puff-block");
            if (categoryPuffBlock) {
                categoryPuffBlock.classList.add("display--none");
            }
        }

        const herbDropdown = document.getElementById("herbDropdown") as HTMLSelectElement;
        if (herbDropdown) {
            herbDropdown.onchange = submitHerbSearch;
        }

        function submitHerbSearch() {
            const herbDropdown = document.getElementById("herbDropdown") as HTMLSelectElement;
            const selectedHerb = herbDropdown.value;

            let query = selectedHerb === "all" ? "" : selectedHerb;

            const newUrl = `${window.location.origin}${window.location.pathname}?q=${encodeURIComponent(query)}`;

            window.location.href = newUrl;
        }

    }

    const recipe = document.querySelector(".recipe-puff") as HTMLElement;
    if (recipe) {
        const saveButtons = document.querySelectorAll<HTMLButtonElement>(".recipe-puff__save-button");

        saveButtons.forEach((button) => {
            button.addEventListener("click", () => {
                button.classList.toggle("recipe--saved");
            });
        });
    }

    if (recipePage) {
        /**
         * Swap between ingredients and instructions
         */
        const ingredientsButton = recipePage.querySelector(".ingredients-button") as HTMLButtonElement;
        const instructionsButton = recipePage.querySelector(".instructions-button") as HTMLButtonElement;
        const ingredientsSection = recipePage.querySelector(".ingredients-section") as HTMLElement;
        const instructionsSection = recipePage.querySelector(".instructions-section") as HTMLElement;

        ingredientsButton.addEventListener("click", () => {
            ingredientsButton.classList.add("active");
            instructionsButton.classList.remove("active");
            ingredientsSection.classList.add("active");
            instructionsSection.classList.remove("active");
        });

        instructionsButton.addEventListener("click", () => {
            instructionsButton.classList.add("active");
            ingredientsButton.classList.remove("active");
            instructionsSection.classList.add("active");
            ingredientsSection.classList.remove("active");
        });

        /**
         * Check checkboxes and save in session-storage
         */



        const isCheckboxChecked = (index: number): boolean => {
            const checkboxes = document.querySelectorAll('.checkbox');

            let isChecked = false;

            checkboxes.forEach((checkbox, currentIndex) => {
                if (currentIndex === index) {
                    const checkboxId = checkbox.id;
                    const isCheckedInStorage = sessionStorage.getItem(checkboxId);

                    isChecked = isCheckedInStorage === 'true';
                }
            });

            return isChecked;
        };


        document.querySelectorAll('.checkbox').forEach((checkbox, index) => {
            checkbox.addEventListener('click', () => {
                checkbox.classList.toggle('checked');
                checkbox.parentElement.classList.toggle('line-through');

                // Determine the checkbox's index from its id
                const checkboxId = checkbox.id;
                const index = checkboxId;


                // Save the state in sessionStorage
                const isChecked = checkbox.classList.contains('checked');
                sessionStorage.setItem(`${index}`, isChecked.toString());
            });

            // Check sessionStorage to restore the state on page load
            if (isCheckboxChecked(index)) {
                checkbox.classList.add('checked');
                checkbox.parentElement.classList.toggle('line-through');
            }
        });
        console.log(sessionStorage);
        /**
         * Copy page URL when click on copy-button.
         */
        const copyButton: HTMLButtonElement | null = document.querySelector(".copy-button");

        if (document.body.contains(copyButton)) {
            const currentURL: string = window.location.href;
            const copyTextContainer: HTMLElement | null = document.querySelector(".copy-status") as HTMLElement;

            copyButton.addEventListener("click", async (e) => {
                try {
                    await navigator.clipboard.writeText(currentURL);
                    copyTextContainer.classList.add("copy-status--copied");

                    setTimeout(() => {
                        copyTextContainer.classList.remove("copy-status--copied");
                    }, 1000);
                } catch (err) {
                    console.error("Unable to copy URL: " + err);
                }
            });
        }


        /**
         * Print page when click on print-button.
         */
        const printButton: HTMLButtonElement | null = document.querySelector(".print-button");

        if (document.body.contains(printButton)) {
            printButton.addEventListener("click", () => {
                window.print();
            })
        }


        /**
         * Share page when click on share-button.
         */
        const shareButton: HTMLButtonElement | null = document.querySelector(".share-button");

        if (document.body.contains(shareButton)) {
            shareButton.addEventListener("click", () => {
                const currentUrl = window.location.href;
                navigator.share({
                    url: currentUrl
                });
            })
        }
    }
}